export default "__VITE_ASSET__C2pLJ$ms__"